import type {
  GetBannerMessagesResponseDTO,
  GetBannerMessagesResponseParamsDTO,
} from 'declarations/dto/notifications';

import { get } from './api';

export const getBannerMessagesApi = async (
  params: GetBannerMessagesResponseParamsDTO
): Promise<GetBannerMessagesResponseDTO> => {
  const response = await get<GetBannerMessagesResponseDTO>(
    '/banner-messages/current-user',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- DTO params are serializable by Axios
    params as any
  );

  return response.data;
};
